import { ORDER_TYPE } from 'common/constants/app.constants';
import { alphaNumericValidatorWithSpecialCharacters, numberValidator, priceValidator } from 'common/utils/validator';

import { formElement } from 'home/view/manage-feasibility/constants';

import { getDate, getFileType } from 'home/view/manage-feasibility/utils';

export const purchaseOrderExpiryDateKey = 'purchaseOrderExpiryDate';

export const formSchema = {
  purchaseOrderNo: { ...formElement, validator: alphaNumericValidatorWithSpecialCharacters },
  purchaseOrderDate: { ...formElement },
  [purchaseOrderExpiryDateKey]: { ...formElement },
  purchaseOrderTotalCharges: { ...formElement, validator: priceValidator },
  files: { ...formElement }
};

export const ignoreKeys = ['touched', purchaseOrderExpiryDateKey, 'purchaseOrderNo', 'purchaseOrderDate', 'purchaseOrderTotalCharges'];

export const getDefaultFiles = (uploadedDocs) => {
  if (uploadedDocs && uploadedDocs.PURCHASE_ORDER) {
    const documents = uploadedDocs.PURCHASE_ORDER;
    return Object.keys(documents).reduce((accumulator, documentName) => {
      const splittedValue = (documents[documentName] && documents[documentName].split('purchase_order/')[1]) || '';
      const name = splittedValue || `document${documentName}`;
      const fileType = splittedValue.split('.')[1];
      const type = getFileType(fileType)?.type;

      return accumulator.concat({ name, size: 100, documentName, type });
    }, []);
  }
  return [];
};

export const getDefaultValue = (order) => {
  const poAmount = order && order.purchaseOrder && order.purchaseOrder.poAmount;
  const poNumber = order && order.purchaseOrder && order.purchaseOrder.poNumber;
  const purchaseOrderDate = order && order.purchaseOrder && order.purchaseOrder.purchaseOrderDate;
  const purchaseOrderExpiryDate = order && order.purchaseOrder && order.purchaseOrder.purchaseOrderExpiryDate;
  const hasPODoc = getDefaultFiles(order.documents).length > 0;
  return {
    // purchaseOrderNo: poNumber
    //   ? {
    //       value: poNumber,
    //       errors: [],
    //       touched: true,
    //       validator: alphaNumericValidatorWithSpecialCharacters
    //     }
    //   : { ...formElement, validator: alphaNumericValidatorWithSpecialCharacters },
    // purchaseOrderDate: purchaseOrderDate ? { value: getDate(purchaseOrderDate), errors: [], touched: true } : { ...formElement },
    // purchaseOrderExpiryDate: purchaseOrderExpiryDate ? { value: getDate(purchaseOrderExpiryDate), errors: [], touched: true } : { ...formElement },
    // purchaseOrderTotalCharges: poAmount
    //   ? {
    //       value: poAmount,
    //       errors: [],
    //       touched: true,
    //       validator: priceValidator
    //     }
    //   : { ...formElement, validator: priceValidator },
    files: hasPODoc
      ? {
          value: 'success',
          errors: [],
          touched: true
        }
      : { ...formElement }
  };
};
